import type { INews } from '@/store/news/INews'
import type { IMessage } from '@/store/messages/interfaces'

export const newsToMessage = (news: INews): IMessage => ({
  id: news.id,
  type: 'news',
  from: '',
  to: '',
  timestamp: news.timestamp,
  status: news.viewed ? 'displayed' : 'received'
})
